import { useAppSelector } from "state/hooks";
import { getGlobalLoadingOverlayState } from "state/slices/global-loading-overlay-slice";
import LoadingOverlay from "./loading-overlay.tsx";

const GlobalLoadingOverlay = () => {
  const { show, message } = useAppSelector(getGlobalLoadingOverlayState);

  return (
    <LoadingOverlay
      show={show}
      message={message}
      fullScreen={true}
    />
  );
};

export default GlobalLoadingOverlay; 